import { useState } from "react";
import { Link } from "react-router-dom";
import TextInput from "./input";
import Section from "./section";

export default function Restricted({ auth, login, post, children }) {
  const [password, setPassword] = useState("");
  const [isError, setIsError] = useState(false);
  const [animationClassName, setAnimationClassName] = useState("");

  const startAnimation = () => {
    setAnimationClassName("shake");
  };
  const onAnimationEnd = () => {
    setAnimationClassName("");
  };

  const handleUpdateField = (e) => {
    e.preventDefault();
    setPassword(e.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    login({ password }).then((response) => {
      console.log("res =>", response);

      // if (response) {
      //   navigate(0);
      // }
      setPassword("");
      setIsError(true);
      startAnimation();
    });
  };

  const loginForm = () => {
    return (
      <Section>
        <div className="md:w-2/3 mx-auto md:px-10 mt-12">
          <div
            id="restricted"
            className={`flex flex-col overflow-hidden rounded-2xl bg-white border-[2px] border-[#0000ee] shadow-[5px_5px_0px_0px_#0000ee] ${animationClassName}`}
            onAnimationEnd={onAnimationEnd}
          >
            <div className="pt-8">
              <h3 className=" text-headingHero text-center font-bold font-serif text-lg">
                This content is locked
              </h3>
            </div>
            <div className="px-8 py-8">
              <div className="rounded-lg border-2 border-dashed border-pink-700 px-4 pt-4 mb-4">
                <p className="inline-block text-xs font-bold mb-2 mr-2">
                  {post.title}
                </p>
                <p className="font-sans font-light text-xs mb-4">
                  {post.subtitle}
                </p>
              </div>
              <form
                className="flex flex-col justify-center"
                htmlFor="login"
                method="post"
                onSubmit={(event) => {
                  handleSubmit(event);
                }}
              >
                <TextInput
                  label="Password"
                  for="password"
                  value={password}
                  type="password"
                  placeholder="Enter your password"
                  isError={isError}
                  onChange={handleUpdateField}
                />
                <input
                  id="login"
                  className="font-serif text-lg text-white bg-link hover:bg-blue-900 cursor-pointer px-3 py-2 mb-4 rounded"
                  type="submit"
                  value="Unlock case study"
                />
              </form>
              <p className="text-xs text-center mb-0">
                If you don't have a password you can request one by contacting
                me on{" "}
                <Link
                  to={"https://www.linkedin.com/in/nick-harris-aa753125"}
                  className="font-sans text-link underline focus:bg-link focus:text-white focus:no-underline"
                >
                  LinkedIn
                </Link>
                .
              </p>
            </div>
          </div>
        </div>
      </Section>
    );
  };

  return (auth.isAuthenticated && post.isLocked) || !post.isLocked
    ? children
    : loginForm();
}
